import React, {useContext} from 'react'
import { EditedContext } from '../../../../partials/Context'
import { Errors } from '../../../../partials/Partials'

function Settlement({errors}) {
    const edited = useContext(EditedContext)
    const {lawyer_data, changeBtn, edited_item, input_value, setInputValue, setEditedItem} = edited || ''
    const {discount, or_per_case, rate_per_hour} = lawyer_data || ''

    return (
    <div className="cost_item profile-section">
        {rate_per_hour || or_per_case || discount ?
            <div className="cost">
                <h1 className="title">Rozliczenia
                {changeBtn('settlement')}
                </h1>
                <Errors errors={errors}/>
                <div className="cost-table">
                    <div className="table-item">
                        <span className="table-title">Stawka za godzinę</span>
                        <hr/>
                        <span className="table-value">
                            {edited_item === 'settlement' ?
                            <input type="text" className="form-input" id="rate_input" value={input_value.rate_per_hour} onChange={(e)=>setInputValue({rate_per_hour: e.target.value})}/>
                            :
                            rate_per_hour ? <span className="value" onClick={() => {
                                setEditedItem('settlement')
                                setInputValue({rate_per_hour: rate_per_hour, discount: discount})
                            }}>{rate_per_hour}<span className="lighter">&nbsp;+ 23% VAT</span></span> : <span className="value" onClick={() => {
                                setEditedItem('settlement')
                                setInputValue({rate_per_hour: rate_per_hour, discount: discount})
                            }}>-</span>} 
                            
                        </span>
                        <hr className="hr"/>
                    </div>
                    <div className="table-item">
                        <span className="table-title">Rozliczenie od sprawy</span>
                        <hr/>
                        <span className="table-value">
                        {edited_item === 'settlement' ?
                        <input type="button" className="form-input" value={input_value.or_per_case  ? 'TAK' : 'NIE'} onClick={()=>setInputValue({...input_value, or_per_case: !input_value.or_per_case })}/>
                        :
                        <span className="value" onClick={() => {
                            setEditedItem('settlement'); setInputValue({...input_value, or_per_case: or_per_case})
                        }}>{or_per_case ? 'TAK' : 'NIE'}</span>
                        }
                        </span>
                        <hr  className="hr"/>
                    </div>
                    <div className="table-item">
                        <span className="table-title">Rabat przy pierwszej konsultacji</span>
                        <hr/>
                        <span className="table-value">
                            {edited_item === 'settlement' ?
                            <>
                            <input type="text" className="form-input"id="discount_input" value={input_value.discount} onChange={(e)=>setInputValue({...input_value, discount: e.target.value})}/> %
                            </>
                            :
                            <span className="value" onClick={() => {
                                setEditedItem('settlement')
                                setInputValue({discount: discount, rate_per_hour: rate_per_hour})
                            }}>{discount ? `${discount}%` : '0%'}</span>
                            }
                        </span>
                        <hr  className="hr"/>
                    </div>
                </div>
            </div>
            : null
        }
    </div>
    )
}

export default Settlement

